<template>
  <div id="basicLayout">
    <div class="menu">
      <div class="company-logo">
        <img
          style="width: 60px; height: 60px"
          src="@/assets/logo.png"
          alt="如赛通"
        />
        如赛通
      </div>
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        :ellipsis="false"
        @select="handleSelect"
      >
        <el-menu-item
          v-for="menuItem in menuItems"
          :index="menuItem.path"
          :key="menuItem.path"
        >
          {{ menuItem.name }}
        </el-menu-item>
      </el-menu>
    </div>
    <!-- 内容区 -->
    <div class="content-wrapper">
      <router-view />
    </div>
    <!-- 底部栏 -->
    <div class="footer">
      <p>版权所有 &copy; 2025 深圳市如赛通科技有限公司</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { routes } from "@/router/router";
import { useRoute, useRouter } from "vue-router";

const router = useRouter();
const route = useRoute();
const activeIndex = ref(route.path);
const menuItems = routes;

const handleSelect = (key: string) => {
  router.push(key);
};

// 监听路由变化，更新 activeIndex
watch(
  () => route.path,
  (newPath) => {
    activeIndex.value = newPath;
  }
);
</script>

<style lang="scss">
#basicLayout {
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.menu {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: rgba(255, 255, 255, 0.6);
  width: 100%;
  position: fixed; /* 固定导航栏 */
  top: 0;
  z-index: 1000;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  .company-logo {
    display: flex;
    align-items: center;
    color: #0098db;
    margin-left: 28px;
    cursor: pointer;
  }

  .el-header {
    color: white;
    line-height: 60px;
    padding: 0; // 去除可能存在的内边距
  }
}

.content-wrapper {
  width: 100%;
  flex: 1; // 让内容区自动扩展填充剩余空间
  margin: 0 auto; /* 水平居中 */
  margin-bottom: 68px;
  //overflow-y: auto; // 当内容超过高度时显示滚动条
}

.footer {
  background-color: #333;
  color: white;
  text-align: center;
  padding: 20px 0; // 调整内边距
}

.el-menu--horizontal.el-menu {
  border-bottom: 1px solid var(--el-menu-border-color);
  background: transparent;
}

.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 2px solid #0098db;
  color: #0098db !important;
  background-color: rgba(255, 255, 255, 0.6) !important;
}
</style>
